// Methods used to record hits to pages/resources for use in popularity sorts

( function ( $ ) {
	var $hitClick = $( '[data-hit-click]' );
	var $videoHitPlay = $( '[data-video-hit-play]' );
	var $hitLoad = $( '[data-hit-load]' );

	$videoHitPlay.each( function() {
		var $curVid = $( this );
		$curVid.on( 'videohit.played', function() {
			var $video = $( this );
			var hitRecorded = $video.data( 'hitRecorded' );

			if ( !hitRecorded ) {
				$video.data( 'hitRecorded', true );
				recordHit( $video );
			}
		} );
	} );

	$hitClick.on( 'click', function( e ) {
		var $node = $( this );
		var delayNavigate = $node.data( 'delayNavigate' );
		if ( delayNavigate && delayNavigate.toLowerCase() === 'true' ) {
			e.preventDefault();
			recordHit( $node, this.href );
		} else {
			recordHit( $node );
		}
	} );

	$hitLoad.each( function() {
		recordHit( $( this ) );
	} );
} )( jQuery );

function recordHit( $node, navigateUrl ) {
	var nodeId = $node.data( 'nodeId' );
	var hitUrl = $node.data( 'hitUrl' );

	if ( nodeId && hitUrl ) {
		$.ajax( {
			type: 'POST',
			url: hitUrl,
			contentType: 'application/json; charset=utf-8',
			data: JSON.stringify( { NodeId: nodeId } ),
			dataType: 'json',
			success: function() {
				if ( navigateUrl ) {
					document.location.href = navigateUrl;
				}
			}
		} );
	}

}